import { isSafari } from "react-device-detect"
import { DEVICE_TYPES, SCREEN_ID } from "./constants"

// is running from iFrame
export const isRunningFromIFrame = () => {
  try {
    return window.self !== window.top
  } catch (e) {
    return true
  }
}

export const isIOSDevice = () => {
  return (
    [
      "iPad Simulator",
      "iPhone Simulator",
      "iPod Simulator",
      "iPad",
      "iPhone",
      "iPod",
    ].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes("Mac") && "ontouchend" in document) ||
    isSafari
  )
}

export const serializeQueryParams = (params) => {
  const url = new URL(window.location.href)
  const searchParams = new URLSearchParams(url.search)
  Object.keys(params).forEach((key) => searchParams.set(key, params[key]))
  const newUrl = `${url.origin}${url.pathname}?${searchParams.toString()}`
  window.history.pushState({ path: newUrl }, "", newUrl)
  return searchParams.toString()
}

export const findLast = (array, predicate) => {
  return array.reduceRight((acc, current) => {
    if (acc === undefined && predicate(current)) {
      return current
    }
    return acc
  }, undefined)
}

export const getModuleTypeImage = (moduleTypeId) => {
  switch (moduleTypeId) {
    case 1:
      return "vocabulario-s.png"
    case 2:
      return "gramatica-s.png"
    case 7:
      return "emociones.png"
    case 6:
    case 9:
      return "canción-s.png"
    case 10:
      return "mate.png"
    case 11:
      return "cuento.png"
    case 8:
      return "examen-s.png"
    case 12:
    case 15:
      return "literatura-s.png"
    case 13:
      return "fonéma.png"
    case 14:
      return "situaciones-s.png"
    case 16:
      return "comprehensión de lectura.png"
    case 17:
      return "ensayo-s.png"
    case 18:
      return "diversidad.png"
    case 22:
      return "lectura.png"
    case 23:
      return "ciencias.png"
    case 24:
      return "escritura.png"
    case 26:
      return "comic-s.png"
    case 27:
      return "valores.png"
    default:
      return "literatura-s.png"
  }
}

export const isValidUsername = (username) => {
  // eslint-disable-next-line no-useless-escape
  const re = /^([a-zA-Z0-9\._-]+)$/
  return re.test(String(username).toLowerCase())
}

export const isRunningFromIframe = () => {
  try {
    // get query param from url
    const urlParams = new URLSearchParams(window.location.search)
    const authOrigin = urlParams.get("authOrigin")
    if (authOrigin && authOrigin === "parent") {
      return true
    }
    // return window.self !== window.top
    return false
  } catch (e) {
    return false
  }
}

export const getScreenId = (screenName) => {
  const deviceTypeId = DEVICE_TYPES.WEB
  return SCREEN_ID[deviceTypeId][screenName]
}

